"use client";

import { useAuthStore } from "@/store";

/**
 * Helper: pra onde "Home" deve apontar dado o estado de auth.
 *
 *  • Logado → /dashboard (plataforma)
 *  • Deslogado → / (landing pública)
 *
 * Usado em links que dizem "Voltar para a home" / "Início" em telas de
 * erro, fallback, footer etc — sem ele, o usuário logado era jogado
 * de volta na landing toda vez.
 */
export function useHomeHref(): string {
  const user = useAuthStore((s) => s.user);
  return user ? "/dashboard" : "/";
}
